import React from 'react';
import Link from 'gatsby-link'
const Menu = (props) => {
    const linkClassName = props.active ? 'animated fadeInDown hvr-underline-from-center' : '';
    return (
        <div className={props.active ? 'menu-wrapper menu-active' : 'menu-wrapper'}>
            <div className="menu">
                <div>
                    <ul>
                        <li className={linkClassName}>
                            <Link onClick={props.toggleMenu} to="/">Overview</Link>
                        </li>
                        <li className={linkClassName}>
                            <Link activeClassName="skills" onClick={props.toggleMenu} to="/skills">Skills & Experience</Link>
                        </li>
                        <li className={linkClassName}>
                            <Link onClick={props.toggleMenu} to="/portofolio">My Work</Link>
                        </li>
                        <li className={linkClassName}>
                            <Link onClick={props.toggleMenu} to="/blog">Blog</Link>
                        </li>
                        {/*  <li className={linkClassName}>
                            <a href="https://drive.google.com/file/d/1WaA6915j-skXkM1368EiCMbYWCVCt3wA/view?usp=sharing" target="_blank" > <i className="fa fa-download"></i>Download CV</a>
                        </li> */}
                    </ul >
                </div >
            </div >
        </div >
    )
};

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Navigation/Menu.js